import { validateAge } from '../PersonalInfoWorkflowValidator';

const shouldSkip = (isGoingForward, hasPartner, principalAge, partnerAge) =>
  isGoingForward && validateAge(hasPartner, principalAge, partnerAge)().length === 0;

export default shouldSkip;
